import React from "react";
import {connect} from "react-redux";

const LandingPage = () => (
    <div></div>
);

export default connect()(LandingPage);
